module.exports = __webpack_public_path__ + "media/images/icon/blue/ico_close-7ae82c35b9806e18938d50919e32a609.svg";